// Angular imports
import { AfterViewInit, Injector, Input, ViewChild } from '@angular/core';

// 3rd party imports
import { DxDataGridComponent } from 'devextreme-angular';

// CC-Common imports
import { DataGridFeaturesComponent, CCLocalStorageService, IconConstants } from 'cc-common';

// Component imports
import { MPBaseComponentWithGrid } from '../../_base/mp-base-component-with-grid';

// Service imports
import { ScreenService } from '../../_services/shared-services/screen.service';
import { HelperService } from '../../_services/shared-services/helper.service';
import { PrecisionService } from '../../_services/shared-services/precision.service';

// Constant imports
import { StringFormatConstants } from '../../_constants/string-format-constants';

export class MPSearchBaseComponent extends MPBaseComponentWithGrid implements AfterViewInit {
    @ViewChild('gridFeatures', { static: false }) gridFeatures: DataGridFeaturesComponent;
    @ViewChild(DxDataGridComponent, { static: false }) searchResultGrid: DxDataGridComponent;

    @Input() widgetId: string;
    @Input() searchText: string;

    loadingVisible = false;
    currencyFormat = StringFormatConstants.currencyFormat;
    dateFormat = StringFormatConstants.dateFormat;
    iconFlag = `${IconConstants.FLAG} cc-1-5x cc-cross-icon`;
    iconCheck = `${IconConstants.CHECK_MARK} cc-1-5x cc-check-icon`;
    iconCross = `${IconConstants.CROSS_MARK} cc-1-5x cc-cross-icon`;

    precisionService: PrecisionService;
    helperService: HelperService;

    constructor(protected readonly injector: Injector) {
        super(injector.get(ScreenService), injector.get(CCLocalStorageService), injector.get(HelperService));
        this.helperService = injector.get(HelperService);
        this.precisionService = injector.get(PrecisionService);
        this.currencyFormat = this.precisionService.getCurrencyFormat();
    }

    ngAfterViewInit(): void {
        if (!!this.searchResultGrid && !!this.searchResultGrid.instance) {
            this.searchResultGrid.instance.repaint();
        }
    }

    updateGridSearchStatus(data: any[]): void {
        setTimeout(() => {
            if (!!this.gridFeatures && !!this.gridFeatures.grid && !!this.gridFeatures.grid.instance) {
                this.gridFeatures.grid.instance.searchByText(this.searchText);
                setTimeout(() => {
                    const dataSource = this.gridFeatures.grid.instance.getDataSource();
                    if (!!dataSource && !!dataSource.store()) {
                        const store = dataSource.store();
                        store.totalCount({}).then((storeCount) => {
                            if (storeCount !== data.length || (dataSource.totalCount() === 0 && data.length > 0)) {
                                this.gridFeatures.grid.instance.clearFilter();
                            }
                        });
                    }
                    if (this.gridFeatures.isSearchVisible === false) {
                        this.gridFeatures.onToolbarAction('ShowSearch');
                    }
                }, 500);
            }
        }, 500);
    }

    clearFilters(): void {
        if (!!this.searchResultGrid && !!this.searchResultGrid.instance) {
            this.searchResultGrid.instance.clearFilter();
        }
    }

    getCheckMarkIcon(data: boolean) {
        return data ? this.iconCheck : this.iconCross;
    }

    public setPropertyContext(communityId: number, accountNumber: string, page = 'home', queryString = ''): void {
        this.helperService.openDefaultPropertyPageInNewWindow(communityId, accountNumber, page, queryString);
    }

    public setCommunityContext(communityId: number, page = 'home', queryString = ''): void {
        this.helperService.openDefaultCommunityPageInNewWindow(communityId, page, queryString);
    }
}
